import * as React from "react"
import { Text, TextProps } from "./Text"

export interface NoticeProps {
  readonly title: string
  readonly description: TextProps
}

export const Notice = (p: NoticeProps) =>
  <div className="block block--notice">
    <h2 className="title--m">{p.title}</h2>
    <Text {...p.description} />
  </div>
